<template>
  <div>
    <PageHeader title="Reports" :links="[
      { name: 'home', label: 'Home' },
      { name: 'reports', label: 'Reports' },
      { name: 'customReport', label: 'Custom' },
    ]">
    </PageHeader>
    <div class="home responsive-menu">
      <div v-canAccess="reportRoles">
        <div class="responsive-menu__child responsive-menu__sub-section" v-for="(section, index) in reports"
          :key="index">
          <div class="section-base" v-canAccess="reportRoles">
            <div class="section-base__header space-between">
              <div class="section-base__header-name">
                <div>
                  <i class="fas fa-chart-line"></i>
                </div>
                <div>{{ section.subSection }}</div>
              </div>
            </div>
            <div class="slim">
              <div class="elevated-0 bordered spacer-responsive">
                <div v-for="report in section.reports" :key="report.slug">
                  <inline-button :to="{ name: 'customReports', query: { name: report.slug } }"
                    type="plain-primary responsive-column" :label="report.name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="reports.length === 0" v-canAccess="reportRoles">
        <div class="section-base">
          <div class="section-base__header space-between">
            <div class="section-base__header-name">
              <div>No reports found - create a custom report to fill this page.</div>
            </div>
          </div>
          <inline-button :to="{ name: 'reportSettings' }" type="plain-primary responsive-column"
            label="Create a custom report" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reportRoles } from "@/constants/roles";
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "reports",
  data() {
    return {
      reportRoles,
      showLegacyReports: false,
    };
  },
  components: { PageHeader },
  created: function () {
    this.setPageTitle("Reports");
  },
  mounted: function () {
    this.getReportSettings();
  },
  computed: {
    ...mapGetters({
      reportSettings: "reports/reportSettings",
    }),
    reports() {
      const groupedReports = this.reportSettings?.reportConfigs
        ?.filter(report => report.section === "Custom Reports")
        .reduce((acc, report) => {
          const subSection = report.subSection || 'Uncategorized';
          if (!acc[subSection]) {
            acc[subSection] = [];
          }
          acc[subSection].push(report);
          return acc;
        }, {}) ?? [];

      const arr = Object.entries(groupedReports).map(([subSection, reports]) => ({
        subSection,
        reports,
      }));
      return arr;
    },
  },
  methods: {
    ...mapActions({
      getReportSettings: "reports/getReportSettings",
    }),
  }
};
</script>

<style lang="scss">
.slim {
  display: flex;
  flex-direction: column;
  gap: 0rem;

  &>* {
    padding-left: 1rem;
  }
}
</style>
